import script from "./ActivityDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./ActivityDetail.vue?vue&type=script&setup=true&lang=js"

import "./ActivityDetail.vue?vue&type=style&index=0&id=711e1a0a&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-711e1a0a"]])

export default __exports__